import Script from 'next/script';
import { SezzleScriptProps } from './types';

export default function SezzleScript({ salePrice }: Readonly<SezzleScriptProps>) {
  return (
    <Script
      id="widget-script"
      defer
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
        window.sezzle = new AwesomeSezzle({
          amount: '$${salePrice}',
          renderElement: 'sezzle-widget-container',
          fontWeight: 400,
          textColor: '#000000',
          maxPrice: '100000000',
          // widgetTemplate: {en: 'Starting at $%%price%%/mo with %%logo%% %%info%%'},
        });

        window.sezzle.init();`,
      }}
    />
  );
}
